import { toast } from 'react-toastify';
import LogRocketService from 'services/logRocketService';

/**
 * Handles API error responses by displaying toast messages and optionally logging to LogRocket
 * @param error - The error object from the API response
 * @param defaultMessage - Optional fallback message if no error details are available
 * @param context - Additional context for error tracking
 */
export const handleApiError = (
  error: any,
  defaultMessage: string = 'An error occurred',
  context?: { component?: string; action?: string; userId?: string }
) => {
  const logRocketService = LogRocketService.getInstance();

  // Only log to LogRocket if it's enabled and active
  if (logRocketService.isActive && error instanceof Error) {
    logRocketService.captureError(error, {
      ...context,
      errorType: 'API_ERROR',
      url: error.response?.config?.url,
      status: error.response?.status,
      method: error.response?.config?.method
    });
  }
  // Check if it's a structured API error with message and errors fields
  if (error.response?.data) {
    const { message, errors } = error.response.data;

    // If we have field-specific errors, display them in a more detailed way
    if (errors && Object.keys(errors).length > 0) {
      // Create a formatted error message with all field errors
      const errorFields = Object.entries(errors)
        .map(([field, message]) => `${field}: ${message}`)
        .join(', ');

      toast.error(`${message}: ${errorFields}`);
      return;
    }

    // If we only have a general message
    if (message) {
      toast.error(message);
      return;
    }
  }

  // Fallback error handling for non-structured errors
  toast.error(error.response?.data?.error || defaultMessage);
};
